import { render, staticRenderFns } from "./BackListItem.vue?vue&type=template&id=97ac3d5a"
import script from "./BackListItem.vue?vue&type=script&lang=js"
export * from "./BackListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports